// Configuração central da loja. Valores entre [ ] aguardam confirmação da Babybib.
export const SITE = {
  name: "Babybib",
  tagline: "Costura criativa para bebés",
  maker: "Alexandra",
  isDemo: true,
  instagram: { handle: "@babybib.pt", url: "https://www.instagram.com/babybib.pt/" },
  // WhatsApp da Alexandra, só dígitos com indicativo (ex.: 351912345678). Enquanto estiver vazio, a loja não mostra o botão do WhatsApp.
  // Pode definir-se aqui ou com REACT_APP_WHATSAPP_NUMBER na compilação.
  whatsapp: { number: (process.env.REACT_APP_WHATSAPP_NUMBER || "").replace(/\D/g, "") },
  contact: {
    email: "[email a confirmar]",
    phone: "[telefone a confirmar]",
    location: "Portugal",
  },
  locale: "pt-PT",
  currency: "EUR",
};

export const NAV = [
  { to: "/loja", label: "Loja", testId: "nav-link-shop" },
  { to: "/catalogo", label: "Catálogo", testId: "nav-link-catalogo" },
  { to: "/tecidos", label: "Tecidos", testId: "nav-link-patterns" },
  { to: "/sobre", label: "Sobre", testId: "nav-link-about" },
];

export const LEGAL_PAGES = [
  { slug: "envios", title: "Envios" },
  { slug: "devolucoes", title: "Trocas e devoluções" },
  { slug: "privacidade", title: "Política de privacidade" },
  { slug: "termos", title: "Termos e condições" },
];

// Ligação que abre uma conversa com a Alexandra, com a mensagem já escrita (ela só tem de enviar). Sem número configurado, devolve null.
export const whatsappUrl = (text) => (SITE.whatsapp.number ? `https://wa.me/${SITE.whatsapp.number}${text ? `?text=${encodeURIComponent(text)}` : ""}` : null);
